export default "__VITE_ASSET__Cyk8Jn0t__"